import { gql } from '@apollo/client/core';

const publicPortfolioHeroQuery = gql`
  query PublicPortfolioHero($slug: String!) {
    publicPortfolioUser(slug: $slug) {
      firstname
      connections {
        totalCount
      }
      configuration {
        sectionConnectionsIsPublic
        fieldPhoneIsPublic
        fieldPublicEmailIsPublic
        fieldLinkedinSlugIsPublic
        fieldCalendarLinkIsPublic
      }
    }
  }
`;

export default publicPortfolioHeroQuery;
